var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 211,
    viewBox: "0 0 238 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1436 28.2054C73.1436 20.9899 78.9928 15.1406 86.2083 15.1406L180.955 15.1406L180.955 154.868C180.955 162.084 175.106 167.933 167.89 167.933L73.1436 167.933L73.1436 28.2054Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.528 15.1406L182.169 15.1406C189.385 15.1406 195.234 20.9899 195.234 28.2054L195.234 67.0483C195.234 74.2637 189.385 80.113 182.169 80.113L174.528 80.113L174.528 15.1406Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7061,
    y: 40.1299,
    width: 70.6842,
    height: 19.2775,
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_486)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.893 128.165L148.893 80.0698L156.258 80.0698C156.628 78.6303 157.649 77.4517 158.987 76.865C159.119 76.7179 159.273 76.5842 159.45 76.4682L189.864 56.5418C192.086 55.0861 195.238 55.5828 196.904 57.6512L197.227 58.0522C200.144 61.6719 199.356 66.6714 195.468 69.2188L184.411 76.4627L192.994 76.4627C193.011 76.4624 193.029 76.4623 193.047 76.4623L204.499 76.4623C206.491 76.4623 208.106 78.0773 208.106 80.0694L208.106 86.0813C208.106 88.0735 206.491 89.6885 204.499 89.6885L194.774 89.6885L194.774 89.6891L201.832 89.6891C203.825 89.6891 205.44 91.3041 205.44 93.2962L205.44 98.1057C205.44 100.098 203.825 101.713 201.832 101.713L199.235 101.713C201.196 101.748 202.775 103.35 202.775 105.319L202.775 111.331C202.775 113.324 201.16 114.938 199.168 114.938L194.774 114.938L194.774 115.005C197.044 115.39 198.772 117.367 198.772 119.746L198.772 123.354C198.772 125.733 197.044 127.71 194.774 128.095L194.774 128.165L157.309 128.165L156.106 128.165L148.893 128.165Z",
    fill: "#FFDCD5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 135.379,
    width: 63.7262,
    height: 133.464,
    transform: "rotate(-90 1 135.379)",
    fill: "#374969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_486)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.464,
    y: 131.772,
    width: 56.5119,
    height: 14.4286,
    transform: "rotate(-90 134.464 131.772)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 128,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 128,
    r: 4,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_486",
    x: 144.893,
    y: 55.707,
    width: 67.2139,
    height: 80.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_486",
    x: -3,
    y: 71.6523,
    width: 141.464,
    height: 71.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_486",
    x: 130.464,
    y: 75.2607,
    width: 22.4285,
    height: 64.5117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 210,
    fill: "white",
    transform: "translate(0.5 0.505859)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceBody2);
export default __webpack_public_path__ + "static/media/IcComplaintServiceBody2.ca6d2366151158dd36e2caeed19720d6.svg";
export { ForwardRef as ReactComponent };